import { MutationResponse, SuccessResponse } from "config";
import { gql } from "config/graphql";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

interface IVerifyEmailData {
  verifyEmail: SuccessResponse;
}

export const verifyEmailMutation: MutationResponse<string, IVerifyEmailData> = async (
  token: string
) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation verifyEmail($input: VerifyEmailInput!) {
      verifyEmail(input: $input) {
        response {
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<IVerifyEmailData>({
    variables: {
      input: { token },
    },
    mutation,
  });
  return { data: assertDefined(data) };
};
